module.exports = __webpack_public_path__ + "static/media/add-student.9ad3707c.png";